<template>
  <div class="modal warning fade" :class="{'is-open': open}">
    <div class="modal-dialog modal-sm">
      <div class="modal-content">
        <div class="modal-body" :class="{'section-loading': loading_from_family}">
          <div v-if="!checkComfirm" class="warning">
            <img width="48"
            :src="`${BaseUrl}assets/common/warning.png`"
            :srcset="`${BaseUrl}assets/common/warning@2x.png`">
            <span class="text">您確定要刪除「{{inputData.name}}」嗎？</span>
          </div>
          <div v-else class="warning">
            <img width="48"
            :src="`${BaseUrl}assets/common/warning.png`"
            :srcset="`${BaseUrl}assets/common/warning@2x.png`">
            <span v-if="isHouseholder" class="text">「{{inputData.name}}」為家戶戶長，刪除會導致家戶解散，原家戶成員皆需重新歸戶，且自行輸入的其他保單也會跟著刪除。請再次確認是否刪除？</span>
            <span v-else class="text">確認刪除後資料將無法回復，請確認是否刪除？</span>
          </div>
          <div class="action text-right">
            <a @click="$emit('close')" class="btn btn-default">取消</a>
            <a v-if="!checkComfirm" @click="checkComfirm = true" class="btn btn-default">確定</a>
            <a v-else @click="$emit('confirm')" class="btn btn-red">確認刪除</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import { getFamilyMemberByCsidNo } from "../../service/index";

export default {
  name: 'CustConfirmDelete',
  computed: {
    ...mapGetters(['BaseUrl'])
  },
  data () {
    return {
      checkComfirm: false,
      isHouseholder: false,
      loading_from_family: false
    }
  },
  watch: {
    open (val) {
      this.checkComfirm = false;
      if (val) {
        this.checkHouseholder();
      }
    },
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    inputData: {
      type: [ Object , String ],
      default: () =>{
        return {}
      }
    },
  },
  methods:{
    checkHouseholder() {
      this.isHouseholder = false;
      this.loading_from_family = true;

      let req_id = this.inputData.ID || this.inputData.serNo;

      getFamilyMemberByCsidNo(this.$store.state.userInfo.id, req_id).then(
        familyResult => {
          if (
            familyResult.header &&
            familyResult.header.status === "200" &&
            familyResult.data
          ) {
            if (
              familyResult.data.length > 0 &&
              familyResult.data[0].familyid == req_id
            ) {
              this.isHouseholder = true;
            }
          } else {
            this.isHouseholder = false;
          }

          this.loading_from_family = false;
          setTimeout(() => {
            this.registerHanlink();
          }, 200);
        }
      );
    }
  }
}
</script>
